import { additionalFieldsData } from 'variables/additional-fields-data';

export const getAdditionalFieldTypeData = (name, additionalFields = []) => {
  const field = additionalFields?.find((el) => el?.name === name);
  return additionalFieldsData?.[field?.type];
};
